import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'math-lower', 'IconMathLower', [["path",{"d":"M19 18l-14 -6l14 -6","key":"svg-0"}]]);